import { render, staticRenderFns } from "./VoipDetails.vue?vue&type=template&id=08be4d5c&"
import script from "./VoipDetails.vue?vue&type=script&lang=js&"
export * from "./VoipDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports